import Navigo from 'navigo';
const navigo = new Navigo('/');
export default navigo;